import React, { useEffect, useState, useMemo } from "react";
import { Upload, Pencil, Trash2, Plus, Play, Pause } from "lucide-react";
import { APIEND_POINT, APIUtility } from "../../../Api";
import { addToast } from "../../../Redux/CommonSlice/toastSlice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/Common/Loader";
import NoData from "../../../components/Common/NoData";
import ConfrimModal from "../../../Modal/ConfrimModal";
import Selectbox from "../../../components/Common/Selectbox";
import { setSoundTypes } from "../../../Redux/CommonSlice/allDataSlice";


let audio = null;

const PlayAudioFile = (data, setAudioPlay, audioPlay) => {
  const playFilePath = APIEND_POINT + data?.alert_voice.slice(1);

  // If there is an audio currently playing, pause it first
  if (audio && audio.src !== playFilePath) {
    audio.pause();
    audio = null;
  }

  // If the clicked audio is already playing, toggle play/pause
  if (audioPlay?.id === data?.alert_media_id) {
    toggleAudioPlayPause();
    setAudioPlay(null)
  } else {
    // Set the new audio source
    audio = new Audio(playFilePath);
    setAudioPlay({
      id: data?.alert_media_id,
      path: playFilePath
    });

    // Play the audio
    audio.play().then(() => {

    }).catch((error) => {
      console.error("Error playing audio:", error);
    });

    // Add an event listener for the 'ended' event
    audio.addEventListener('ended', () => {

      audio = null;  // Reset audio object when finished
      setAudioPlay(null);
    });
  }
};

const toggleAudioPlayPause = () => {
  if (audio) {
    if (audio.paused) {
      audio.play().then(() => {

      }).catch((error) => {
        console.error("Error playing audio:", error);
      });
    } else {
      audio.pause();

    }
  }
};


function AlertComponent({ permissions }) {
  const [configurations, setConfigurations] = useState([]);
  const [newConfig, setNewConfig] = useState(null);
  const [editData, setEditData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [confrimModalShow, setConfrimModalShow] = useState(false);
  const [alertConfigId, setAlertConfigId] = useState(null);
  const [ErrorMessage, setErrorMessage] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState(null);
  const [audioPlay, setAudioPlay] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const dispatch = useDispatch();
  const soundTypes = useSelector((state) => state.data.soundTypes);

  const configNameOptions = useMemo(() => {
    return soundTypes.map(type => ({
      label: type.configure_name,
      value: type.name,
    }));
  }, [soundTypes]);

  const handleAddNewConfig = () => {
    const defaultSoundType = soundTypes.length > 0 ? {
      configure_name: soundTypes[0].configure_name,
      sound_type: soundTypes[0].name
    } : { configure_name: "", sound_type: "" };

    setNewConfig({
      configure_name: defaultSoundType.configure_name,
      sound_type: defaultSoundType.sound_type,
      alert_voice: null,
      alert_api: "http://127.0.0.1:5000",
    });
    setIsEditing(false);
  };

  const handleEditConfig = (data) => {
    // setNewConfig(configurations[index]);
    setIsEditing(true);
    setEditData({
      ...data,
      alert_api: data.alert_api || "http://127.0.0.1:5000"
    });
    setEditIndex(data.alert_media_id);
  };

  const handleVoiceFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "audio/mpeg" || file.name.endsWith('.mp3')) {
        setNewConfig({ ...newConfig, alert_voice: file });
        setFileErrorMessage(null);
      } else {
        setFileErrorMessage("Only MP3 files Are Allowed");
        e.target.value = null; // Reset the input
        setTimeout(() => {
          setFileErrorMessage(null);
        }, 5000);
      }
    }
  };

  const getAlertNotification = async () => {
    setIsLoading(true);
    try {
      const res = await APIUtility.GetAlertNotificationMedia();
      if (res.status == 200) {
        setConfigurations(res.data.alert_media || []);
        if (res.data.sound_types && res.data.sound_types.length > 0) {
          dispatch(setSoundTypes(res.data.sound_types));
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  function validateURL(value) {
    // Regular expression to validate URLs, including localhost and other valid URLs
    const urlPattern = new RegExp(
      "^" +
      "(https?:\\/\\/)?" + // protocol
      "(localhost|" + // localhost or
      "\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|" + // or IP address
      "\\[([a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}\\]|" + // or IPv6
      "([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,})" + // or domain
      "(:[0-9]{1,5})?" + // port (optional)
      "(\\/.*)?$", // path (optional)
      "i"
    );
    return urlPattern.test(value);
  }

  const AddAlertNotification = async () => {
    const formData = new FormData();
    formData.append("alert_api", newConfig.alert_api);
    formData.append("configure_name", newConfig.configure_name);
    formData.append("sound_type", newConfig.sound_type);
    formData.append("alert_voice", newConfig.alert_voice);

    if (validateURL(newConfig.alert_api)) {
      try {
        const res = await APIUtility.AddAlertNotificationMedia(formData);

        if (res.status == 201) {
          dispatch(
            addToast({
              message: "Alert Configuration Added Successfully",
              isError: false,
            })
          );
          setNewConfig(null);
          getAlertNotification();
        }
      } catch (error) {
        console.log(error, "error");
        setConfigurations([]);
        dispatch(
          addToast({
            message: error.message || "Failed to add Alert Configuration",
            isError: true,
          })
        );
      }
    } else {
      setErrorMessage("Enter Valid Url Or Link,Api");
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
    }
  };

  const UpdateAlertNotification = async (id) => {
    setIsUpdating(true);
    const formData = new FormData();
    formData.append("alert_api", editData.alert_api);
    formData.append("configure_name", editData.configure_name);
    formData.append("sound_type", editData.sound_type);
    if (typeof editData.alert_voice != "string") {
      formData.append("alert_voice", editData.alert_voice);
    }
    formData.append("id", id);

    if (validateURL(editData.alert_api)) {
      try {
        const res = await APIUtility.UpdateAlertNotificationMedia(formData);
        if (res.status == 201 || res.status == 200) {
          dispatch(
            addToast({
              message: "Alert Configuration Updated Successfully",
              isError: false,
            })
          );
          setNewConfig(null);
          setEditData(null);
          setEditIndex(null);
          setIsEditing(false);
          getAlertNotification();
        }
      } catch (error) {
        console.log(error, "error");
        dispatch(
          addToast({
            message: error.message || "Failed to update Alert Configuration",
            isError: true,
          })
        );
      } finally {
        setIsUpdating(false);
      }
    } else {
      setErrorMessage("Enter Valid Url Or Link,Api");
      setTimeout(() => {
        setErrorMessage(null);
      }, 5000);
      setIsUpdating(false);
    }
  };

  useEffect(() => {
    getAlertNotification();
  }, []);


  const TableColumn = [
    {
      name: "Configuration Name",
      className: "w-[26.6666666667%]",
    },
    {
      name: "Alert Voice",
      className: "w-[26.6666666667%]",
    },
    {
      name: "Alert API",
      className: "w-[26.6666666667%]",
    },
    {
      name: "Action",
      className: "w-[20%] !text-center",
    },
  ];

  const DeleteUserdata = async () => {
    try {
      const res = await APIUtility.DeleteAlertNotificationMedia({
        id: alertConfigId,
      });
      if (res.status == 204) {
        setConfrimModalShow(false);
        getAlertNotification();
        // setUserId(null);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };



  return (
    <div className="flex flex-col w-full font-roboto relative ">
      <div className="flex justify-between items-center h-12 w-full mb-[10px]">
        <p className="text-lg text-black/50 font-semibold font-['Roboto']">
          Alert
        </p>
        <div className="flex gap-2 h-12">
          {
            permissions?.alert_notification_add_button && <button
              className="px-3.5 py-3 text-white font-medium font-['Roboto'] cursor-pointer bg-green-500 rounded-md h-11 gap-2 flex items-center"
              onClick={handleAddNewConfig}
            >
              <Plus color="#FFFFFF" />
              <span>New Configuration</span>
            </button>
          }
        </div>
      </div>
      <div>
        <div className="h-alerttable_h overflow-y-scroll hideScrollBar absolute top-[55px]">
          <table className="w-full relative border-collapse bg-white rounded-md table-fixed">
            <thead className="w-full z-10 bg-white">
              <tr>
                {TableColumn.map((item, i) => {
                  if ((!permissions?.alert_notification_edit_button || !permissions?.alert_notification_delete_button) && item.name == 'Action') {

                  } else {

                    return (
                      <th
                        key={i}
                        className={`h-full sticky bg-white top-0 text-left border-r border-black/10 gap-2.5 text-black/50 font-medium font-['Roboto'] ${item.className}`}
                      >
                        <div
                          className={`gap-[10px] border-b-[2px] border-[#D3D3D3] p-[10px] whitespace-nowrap px-3 ${item.name == "Action" ? "text-center " : "text-left"
                            }`}
                        >
                          {item.name}
                        </div>
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            <tbody>
              {newConfig && (
                <tr className="h-16 border-b border-black/10">
                  <td className="px-3 py-2 border-r border-black/10">
                    <Selectbox
                      data={configNameOptions}
                      SelectClass={"!h-[41.6px]"}
                      onSelect={(value) => {
                        setNewConfig({
                          ...newConfig,
                          configure_name: value[0]?.label || "",
                          sound_type: value[0]?.value || "",
                        });
                      }}
                      placeholder="Select Configuration Type"
                    />
                  </td>
                  <td className="px-3 py-2 border-r border-black/10">
                    <div className="flex items-center gap-2 border rounded px-3 py-2 relative">
                      <label
                        htmlFor="fileInput"
                        className="flex items-center cursor-pointer text-blue-600"
                      >
                        <Upload />
                        <span className="ml-2">
                          {newConfig?.alert_voice
                            ? newConfig?.alert_voice.name
                            : "Upload Voice"}
                        </span>
                      </label>
                      <input
                        id="fileInput"
                        type="file"
                        accept="audio/*"
                        onChange={handleVoiceFileChange}
                        className="hidden"
                      />
                      {fileErrorMessage && (
                        <p className="m-0 text-red-600 text-[10px] absolute bottom-[-2px]">
                          {fileErrorMessage}
                        </p>
                      )}
                    </div>
                  </td>
                  <td className="px-3 py-2 border-r border-black/10 relative">
                    <input
                      type="text"
                      value={newConfig.alert_api}
                      onChange={(e) =>
                        setNewConfig({
                          ...newConfig,
                          alert_api: e.target.value,
                        })
                      }
                      placeholder="API Link"
                      className="w-full px-3 py-2 border rounded border-black/20 outline-none"
                    />
                    {ErrorMessage && (
                      <p className=" m-0 text-red-600 text-[10px] absolute bottom-[-2px]">
                        {ErrorMessage}
                      </p>
                    )}
                  </td>
                  <td className="px-3 py-2 text-center flex items-center justify-center gap-2">
                    <button
                      className={`px-4 py-2 flex items-center justify-center rounded h-[45px] text-white bg-customGreen font-['Roboto'] font-semibold`}
                      onClick={AddAlertNotification}
                    >
                      Add
                    </button>
                    <button
                      className="p-2 rounded bg-white border-2 text-black w-[80px] h-[45px] flex items-center justify-center"
                      onClick={() => {
                        setNewConfig(null);
                      }}
                    >
                      Cancel
                    </button>
                  </td>
                </tr>
              )}

              {isLoading ? (
                <tr>
                  <td className="h-[calc(100vh-260px)] w-full" colSpan={4}>
                    <div className="w-full h-full flex items-center justify-center">
                      <Loader />
                    </div>
                  </td>
                </tr>
              ) : (!configurations || configurations.length === 0) && !newConfig ? (
                <tr>
                  <td className="h-[calc(100vh-260px)] w-full" colSpan={4}>
                    <div className="w-full h-full flex items-center justify-center">
                      <NoData text={"No Alert Configuration Added"} />
                    </div>
                  </td>
                </tr>
              ) : (
                configurations.map((config, index) => (
                  <tr
                    className="h-16 border-b border-black/10 font-bold"
                    key={index}
                  >
                    <td className="px-3 py-2 border-r border-black/10">
                      {isEditing && editIndex == config.alert_media_id ? (
                        <Selectbox
                          data={configNameOptions}
                          SelectClass={"!h-[41.6px]"}
                          defaultValue={configNameOptions.filter(
                            (option) => option.label === editData?.configure_name
                          )}
                          onSelect={(value) => {
                            setEditData({
                              ...editData,
                              configure_name: value[0]?.label || "",
                              sound_type: value[0]?.value || "",
                            });
                          }}
                          placeholder="Select Configuration Type"
                        />
                      ) : (
                        config.configure_name
                      )}
                    </td>
                    <td
                      className="px-3 py-2 border-r border-black/10 break-words"
                      title={editData?.alert_voice}
                    >
                      {isEditing && editIndex == config.alert_media_id ? (
                        <div className="flex items-center gap-2 border rounded px-3 py-2 line-clamp-1 overflow-hidden w-full text-ellipsis break-words relative">
                          <label
                            htmlFor="fileInput"
                            className="flex items-center cursor-pointer text-blue-600"
                          >
                            <Upload />
                            <span className="ml-2 ">
                              {editData?.file_name
                                ? typeof editData.file_name == "string"
                                  ? editData?.file_name
                                  : editData?.file_name
                                : "Upload Voice"}
                            </span>
                          </label>
                          <input
                            id="fileInput"
                            type="file"
                            accept="audio/mpeg"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                if (file.type === "audio/mpeg" || file.name.endsWith('.mp3')) {
                                  setEditData({
                                    ...editData,
                                    alert_voice: file,
                                    file_name: file.name
                                  });
                                  setFileErrorMessage(null);
                                } else {
                                  setFileErrorMessage("Only MP3 files Are Allowed");
                                  e.target.value = null; // Reset the input
                                  setTimeout(() => {
                                    setFileErrorMessage(null);
                                  }, 5000);
                                }
                              }
                            }}
                            className="hidden"
                          />
                          {fileErrorMessage && (
                            <p className="m-0 text-red-600 text-[10px] absolute bottom-[-2px]">
                              {fileErrorMessage}
                            </p>
                          )}
                        </div>
                      ) : config.alert_voice ? (
                        <div className=" flex items-center gap-1">
                          {config.file_name}  <div className="">
                            {audioPlay?.id === config?.alert_media_id
                              ? <Pause className="cursor-pointer text-red-600" size={20} onClick={() => PlayAudioFile(config, setAudioPlay, audioPlay)} />
                              : <Play className="cursor-pointer text-green-600" size={20} onClick={() => PlayAudioFile(config, setAudioPlay, audioPlay)} />
                            }
                          </div>
                        </div>
                      ) : (
                        "No file chosen"
                      )}
                    </td>
                    <td className="px-3 py-2 border-r border-black/10 break-words">
                      {isEditing && editIndex == config.alert_media_id ? (
                        <div className=" relative">
                          <input
                            type="text"
                            value={editData?.alert_api}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                alert_api: e.target.value,
                              })
                            }
                            placeholder="API Link"
                            className="w-full px-3 py-2 border rounded border-black/20 outline-none"
                          />
                          {ErrorMessage && (
                            <p className=" m-0 text-red-600 text-[10px] absolute bottom-[-2px]">
                              {ErrorMessage}
                            </p>
                          )}
                        </div>
                      ) : (
                        config.alert_api
                      )}
                    </td>
                    {
                      (permissions?.alert_notification_edit_button || permissions?.alert_notification_delete_button) && <td className="px-3 py-2 text-center">
                        <div className="flex justify-center gap-2">
                          {isEditing && editIndex == config.alert_media_id ? (
                            <div className="text-center flex items-center gap-2">
                              <button
                                className="border flex items-center justify-center rounded bg-customGreen text-white h-[45px] px-3 py-2 font-['Roboto'] font-semibold"
                                onClick={() => UpdateAlertNotification(config.alert_media_id)}
                                disabled={isUpdating}
                              >
                                {isUpdating ? (
                                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                                ) : null}
                                {isUpdating ? "Updating" : "Update"}
                              </button>
                              <button
                                className="p-2 rounded bg-white border-2 text-black font-normal w-[80px] h-[45px]"
                                onClick={() => {
                                  setIsEditing(false);
                                  setEditData(null);
                                  setEditIndex(null);
                                }}
                                disabled={isUpdating}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <div className="flex items-center gap-2">
                              {
                                permissions?.alert_notification_edit_button && <button
                                  className="p-2 bg-green-300/20 rounded"
                                  onClick={() => handleEditConfig(config)}
                                >
                                  <Pencil className="text-black" />
                                </button>
                              }
                              {
                                permissions?.alert_notification_delete_button && <button
                                  className="p-2 bg-red-100 rounded"
                                  onClick={() => {
                                    setAlertConfigId(config.alert_media_id);
                                    setConfrimModalShow(true);
                                  }}
                                >
                                  <Trash2 className="text-red-600" />
                                </button>
                              }

                            </div>
                          )}
                        </div>
                      </td>
                    }
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ConfrimModal
        show={confrimModalShow}
        onHide={() => setConfrimModalShow(false)}
        onYesClick={DeleteUserdata}
        heading={"Delete Alert Configration"}
        message={"Are you sure you want to delete this Alert Configration?"}
      />

    </div>
  );
}

export default AlertComponent;
